module.exports = {
  name: "Deutsch",
  key: "de",
  'Open in Debug Map': 'In Debug Map öffnen',
  'Open in Mapillary': 'In Mapillary öffnen',
  'GPX': 'GPX-Datei exportieren',
  'Open in editor': 'Im Editor öffnen',
  'Open in JOSM': 'In JOSM öffnen',
  'Select language': 'Sprache auswählen',
  'Share Route': 'Route teilen',
  'Link': 'Link',
  'Shortlink': 'Kurzlink',
  'Start - press enter to drop marker': 'Start - drücken um einen Marker zu plazieren',
  'End - press enter to drop marker': 'Ende - drücken um einen Marker zu plazieren',
  'Via point - press enter to drop marker': 'Zwischenstop - drücken um einen Marker zu plazieren',
  'Bike': 'Fahrrad',
  'Car': 'Auto',
  'Foot': 'Fussgänger',
  'Build': 'Build: '
};
